import React from "react";

const Quote = () => {
  return (
    <section id="quote-page" className="py-2">
      <div className="container">
        <div className="two-card-container">
          <article className="card">
          <h2>Contact Us</h2>
            <p>
              We are delighted to assist you with any inquiries or requests
              regarding our flooring services. Whether you're looking for
              information about our products, seeking professional advice, or
              wish to discuss a potential project, we are here to help.
            </p>
            <br />
            <p>
              At our company, we prioritize effective communication and
              exceptional customer service. Our dedicated team of flooring
              experts is ready to address your questions, provide detailed
              guidance, and offer personalized solutions tailored to your
              specific needs.
            </p>
            <br />
            <p>
              We understand that choosing the right flooring is an important
              decision, and we want to ensure you have all the information and
              support you need to make the best choice for your space. Our team
              is experienced, friendly, and committed to exceeding your
              expectations.
            </p>
            <br />
            <p>
              Don't hesitate to get in touch with us. We look forward to hearing
              from you and assisting you on your flooring journey.
            </p>
          </article>
          <article className="card">
            <div className="contact-details">
              <h3>Location</h3>
              <p>131 Amesbury Drive, Churton Park, Wellington 6037</p>
              <h3>Phone</h3>
              <p>021 198 0618</p>
              <h3>Email</h3>
              <p>junifer@pedresflooring.co.nz</p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Quote;
